import {resizeMediaByWidth} from '@wix/wixstores-client-core';
import {LineItemModel} from '../models/LineItems/LineItem.model';

type MediaDimensions = {width: number; height: number};

export const getImageDimensions = (
  lineItem: LineItemModel,
  defaultDimensions: MediaDimensions,
  fixImageDimensions?: boolean
): MediaDimensions => {
  const primaryImage = lineItem.attributes.image;

  if (!primaryImage || (fixImageDimensions && (!primaryImage.width || !primaryImage.height))) {
    return defaultDimensions;
  }

  return resizeMediaByWidth(primaryImage, 100);
};
